export default "__VITE_PUBLIC_ASSET__5f430cfd__"